import React from 'react'
import './Factura.css';
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import Api from "../../services/Api";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAt, faCalendarAlt, faDollarSign, faEdit, faHashtag, faPlus, faPrint, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        forma_pago: '',
        abono_factura: '',
        animateInfo: false,
        showInfoModal: false,
        facturas: [],
        detalles: [],
        pagos: [],
        procedimientos: [],
        errors: []
    }
    sessionExpired = () => {
        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
        window.localStorage.clear();
        window.location.href = '/';
    }
    // changeValue = (e) => {
    //     const state = this.state.facturas;
    //     state[e.target.name] = e.target.value;
    //     this.setState({ facturas: state });
    // };
    changeValue = (e) => {
        const state = this.state;
        state[e.target.name] = e.target.value;
        this.setState({ state, errors: [] })
    }
    errorVerify(element) {
        return this.state.errors.indexOf(element) !== -1;
    }
    abonarFactura = async (e) => {
        e.preventDefault();
        const { forma_pago, abono_factura } = this.state;
        var errors = [];
        if (!forma_pago) { errors.push("error_forma_pago"); }
        if (!abono_factura) { errors.push("error_abono_factura"); }
        console.log(errors.length);
        this.setState({ errors: errors });
        if (errors.length > 0) {
            return false;
        }
        var dataAbono = {
            id_factura: this.props.match.params.id,
            forma_pago: forma_pago,
            abono_factura: abono_factura,
            user_id: window.localStorage.getItem('idusuario')
        }
        try {
            Swal.fire({
                title: 'Guardando...',
                text: 'Por favor, Espere',
                allowOutsideClick: false,
                didOpen: () => Swal.showLoading(),
            });
            const AbonoDataRes = await authAxios.post("facturas/abonar_factura", dataAbono);
            if (!AbonoDataRes.data.status) {
                this.sessionExpired();
                return;
            }
            Swal.close();
            Swal.fire(
                'Facturas!',
                AbonoDataRes.data.message,
                'success'
            );
            this.setState({
                datosCargados: true,
                facturas: AbonoDataRes.data.factura,
                detalles: AbonoDataRes.data.detalles,
                pagos: AbonoDataRes.data.pagos,
                forma_pago: '',
                abono_factura: '',
                load: ''
            });
        } catch (error) {
            console.error(error);
            Swal.close();
        }
    }
    openFacturaModal = async (id_factura) => {
        try {
            Swal.showLoading();
            const dataResult = await authAxios.get(`facturas/view/${id_factura}`);
            if (dataResult.data.status) {
                this.setState({
                    factura: dataResult.data.factura,
                    detalles: dataResult.data.detalles,
                    pagos: dataResult.data.pagos,
                    showInfoModal: true
                }, () => {
                    setTimeout(() => this.setState({ animateInfo: true}), 10);
                })
                Swal.close();
            }
        } catch (error) {
            console.error(error);
        }
    }
    closeFacturaModal = () => {
        this.setState({ animateInfo: false })
        setTimeout(() => {
            this.setState({ showInfoModal: false });
        }, 300);
    }
    printFactura = () => {
        window.print();
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("facturas/view/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                Swal.showLoading();
                console.log(datosRespuesta);
                this.setState({
                    datosCargados: true,
                    facturas: datosRespuesta.data.factura,
                    detalles: datosRespuesta.data.detalles,
                    pagos: datosRespuesta.data.pagos,
                    load: ''
                });
                Swal.close();
            })
            .catch(console.log);
    }
    render() {
        const { load, forma_pago, abono_factura, facturas, detalles, showInfoModal, animateInfo, pagos } = this.state;
        return (
            <div className="content-wrapper">
                <div className="content">
                    <div className="container-fluid">
                        <br />
                        <div className="card">
                            <div className="card-header text-center">
                                {load ? (<b>{load}</b>) : (<b>VER / ABONAR FACTURA</b>)}
                            </div>
                            <div className="card-body">
                                <form>
                                    <div className="row">
                                        <div className="col-xl-12">
                                            <div className="row g-3">
                                                <div className="col-md-12 text-right">
                                                    {
                                                        facturas.ESTADO === 1 ?
                                                            <button type="button" className="btn btn-secondary btn-sm"
                                                                onClick={() => {
                                                                    this.openFacturaModal(facturas.ID_FACTURA)
                                                                }}
                                                            >
                                                                <FontAwesomeIcon icon={faPrint} />&nbsp;&nbsp;Imprimir Factura
                                                            </button>
                                                        : ''
                                                    }
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN FACTURA</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="factura_id" value={this.props.match.params.id} />
                                                    <input type="hidden" name="user_id" id="user_id" value={window.localStorage.getItem('idusuario')} />
                                                    <label htmlFor="id_factura">No. Factura</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="number" name="id_factura" id="id_factura" defaultValue={facturas.ID_FACTURA}
                                                            className="form-control form-control-sm" placeholder="No. Factura" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className="col-md-6"></div>
                                                <div className="col-md-2">
                                                    <label htmlFor="fecha_factura">Fecha Factura</label>
                                                    <div className={((this.errorVerify("error_fecha_factura")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_factura" id="fecha_factura" value={facturas.FECHA_FACTURA}
                                                            className={((this.errorVerify("error_fecha_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Factura" aria-describedby="helpId"
                                                            onChange={this.changeValue}
                                                        />
                                                    </div>
                                                    <small id="helpId" className="invalid-feedback">Seleccione la Fecha Factura</small>
                                                </div>
                                                <div className='col-md-2'>
                                                    <label htmlFor="estado_factura">Estado</label>
                                                    <input type="text" name="estado_factura" id="estado_factura"
                                                        defaultValue={
                                                            facturas.ESTADO === 2 ? "PENDIENTE" :
                                                            facturas.ESTADO === 1 ? "PAGADA" : ""
                                                        }
                                                        style={{
                                                            textTransform: 'uppercase',
                                                            color: "#FFFFFF",
                                                            fontWeight: "bold",
                                                            backgroundColor:
                                                                facturas.ESTADO === 2 ? "#FFC107" :
                                                                facturas.ESTADO === 1 ? "#198754" : ""
                                                        }}
                                                        className="form-control form-control-sm text-center" placeholder="Estado" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>INFORMACIÓN PACIENTE</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-md-2">
                                                    <input type="hidden" name="id_paciente" id="id_paciente" value={facturas.ID_PACIENTE}  />
                                                    <label htmlFor="id_paciente">Identificación</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="identificacion_paciente" id="identificacion_paciente" value={facturas.IDENTIFICACION} 
                                                            className={"form-control form-control-sm"} placeholder="Identificación" aria-describedby="helpId"
                                                            onChange={this.changeValue} readOnly />
                                                    </div>
                                                </div>
                                                <div className='col-md-4'>
                                                    <label htmlFor="paciente">Paciente</label>
                                                    <input style={{ textTransform: 'uppercase' }} type="text" name="paciente" id="paciente" value={facturas.PACIENTE}
                                                        className="form-control form-control-sm" placeholder="Paciente" aria-describedby="helpId"
                                                        onChange={this.changeValue} readOnly />
                                                </div>
                                                <div className="col-md-2">
                                                    <label htmlFor="celular_paciente">Celular</label>
                                                    <div className="input-group input-group-sm">
                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faHashtag} /></span>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="celular_paciente" id="celular_paciente" value={facturas.CELULAR}
                                                            className="form-control form-control-sm" placeholder="Celular" aria-describedby="helpId"
                                                            readOnly />
                                                    </div>
                                                </div>
                                                {
                                                    facturas.SALDO_PENDIENTE > 0 ?
                                                        <>
                                                            <div className="col-md-2"></div>
                                                            <div className="col-md-2">
                                                                <label htmlFor="saldo_pendiente">Saldo Pendiente</label>
                                                                <div className="input-group input-group-sm">
                                                                    <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                    <input style={{ textTransform: 'uppercase', backgroundColor: '#DC3545', color: '#FFFFFF', fontWeight: 'bold' }}
                                                                        type="text" name="saldo_pendiente" id="saldo_pendiente" value={currencyFormat(facturas.SALDO_PENDIENTE)}
                                                                        className="form-control form-control-sm text-center" placeholder="Celular" aria-describedby="helpId"
                                                                        readOnly />
                                                                </div>
                                                            </div>
                                                        </>
                                                    : ''
                                                }
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>PROCEDIMIENTOS</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">HISTORIA CLÍNICA</th>
                                                                <th className="align-middle">CATEGORIA</th>
                                                                <th className="align-middle">SERVICIO</th>
                                                                <th className="align-middle">PRECIO</th>
                                                                <th className="align-middle">PAGADO</th>
                                                                <th className="align-middle">PENDIENTE</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                detalles.map((itemDetalles) => (
                                                                    <tr key={itemDetalles.ID_DETALLE}>
                                                                        <td>{itemDetalles.ID_HISTORIA_CLINICA}</td>
                                                                        <td>{itemDetalles.CATEGORIA}</td>
                                                                        <td>{itemDetalles.SERVICIO}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemDetalles.PRECIO)}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemDetalles.PAGADO)}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemDetalles.PRECIO - itemDetalles.PAGADO)}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            <hr style={{ marginBottom: 0 }} />
                                            <div style={{ fontSize: 14 }} className="card-header text-center">
                                                <b>PAGOS REALIZADOS</b>
                                            </div>
                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                <div className="col-xl-12">
                                                    <table className="table table-hover table-condensed table-sm">
                                                        <thead className="thead-inverse">
                                                            <tr>
                                                                <th className="align-middle">FORMA PAGO</th>
                                                                <th className="align-middle">FECHA PAGO</th>
                                                                <th className="align-middle">MONTO PAGO</th>
                                                            </tr>
                                                        </thead>
                                                        <tbody>
                                                            {
                                                                pagos.map((itemPagos) => (
                                                                    <tr key={itemPagos.ID_PAGO}>
                                                                        {
                                                                            (() => {
                                                                                switch (itemPagos.FORMA_PAGO) {
                                                                                    case 1:
                                                                                        return (<td>EFECTIVO</td>)
                                                                                    case 2:
                                                                                        return (<td>TARJETA</td>)
                                                                                    case 3:
                                                                                        return (<td>TRANSFERENCIA</td>)
                                                                                }
                                                                            })()
                                                                        }
                                                                        <td>{itemPagos.FECHA_PAGO}</td>
                                                                        <td><b>$ </b>{currencyFormat(itemPagos.MONTO_PAGO)}</td>
                                                                    </tr>
                                                                ))
                                                            }
                                                        </tbody>
                                                    </table>
                                                </div>
                                            </div>
                                            {
                                                facturas.SALDO_PENDIENTE > 0 && (
                                                    <>
                                                        <hr style={{ marginBottom: 0 }} />
                                                        <div style={{ fontSize: 14 }} className="card-header text-center">
                                                            <b>REGISTRAR ABONO</b>
                                                        </div>
                                                        <form id="form">
                                                            <div style={{ marginTop: 0 }} className='row g-3'>
                                                                <div className='col-md-2'>
                                                                    <label htmlFor="forma_pago">Forma Pago</label>
                                                                    <select name="forma_pago"
                                                                        id="forma_pago"
                                                                        className={((this.errorVerify("error_forma_pago")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                                        onChange={this.changeValue}>
                                                                        <option value="">Seleccione la Forma de Pago</option>
                                                                        <option value="1">EFECTIVO</option>
                                                                        <option value="2">TARJETA</option>
                                                                        <option value="3">TRANSFERENCIA</option>
                                                                    </select>
                                                                    <small id="helpId" className="invalid-feedback">Seleccione la Forma de Pago</small>
                                                                </div>
                                                                <div className="col-md-2">
                                                                    <label htmlFor="abono_factura">Abono Factura</label>
                                                                    <div className={((this.errorVerify("error_abono_factura")) ? "is-invalid" : "") + " input-group input-group-sm"}>
                                                                        <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                        <input style={{ textTransform: 'uppercase' }} type="number" step="0.01" name="abono_factura" id="abono_factura" value={abono_factura}
                                                                            className={((this.errorVerify("error_abono_factura")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Abono Factura" aria-describedby="helpId"
                                                                            onChange={this.changeValue}
                                                                        />
                                                                    </div>
                                                                    <small id="helpId" className="invalid-feedback">Digite el Abono Factura</small>
                                                                </div>
                                                                <div className="col-md-1 d-flex align-items-end">
                                                                    <button type="button" className="btn btn-success btn-sm" onClick={this.abonarFactura}
                                                                        disabled={
                                                                            facturas.ESTADO === 1 ? true :
                                                                            facturas.ESTADO === 2 ? false : ""
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faPlus} />
                                                                    </button>
                                                                </div>
                                                            </div>
                                                        </form>
                                                    </>
                                                )
                                            }
                                        </div>
                                    </div>
                                    <hr />
                                    <div className='row'>
                                        <div className='col-xl-12 text-center'>
                                            <div className="btn-group" role="group" aria-label="">
                                                {/* <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Cliente Especial</button>&nbsp;&nbsp; */}
                                                <Link className="btn btn-danger btn-sm" to={"/MasterFacturas"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                            </div>
                                        </div>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                    {
                        showInfoModal && (
                            <>
                                <div style={{ display: 'block' }} className={`modal fade ${animateInfo ? 'show' : ''}`} id="FacturaModal" tabIndex="-1" role="dialog" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="FacturaModalLabel" aria-hidden="true">
                                    <div className="modal-dialog" role="document">
                                        <div className="modal-content">
                                            <div className="modal-header">
                                                <h4 className="modal-title w-100 text-center" id="FacturaModalLabel">Factura</h4>
                                                <button type="button" className="btn-close" onClick={this.closeFacturaModal}></button>
                                            </div>
                                            <div className="modal-body">
                                                <div className='row'>
                                                    <div className='col-xl-12'>
                                                        <div className="ticket text-center">
                                                            <img 
                                                                src="/dist/img/Dents.png"   // 👈 pon aquí la ruta de tu logo
                                                                alt="Logo Empresa" 
                                                                style={{ maxWidth: "120px", marginBottom: "10px" }} 
                                                            />
                                                            <h5 style={{ marginBottom: "0px" }}>Dents Colombia</h5>
                                                            <p style={{ marginBottom: "0px" }}>901093502-2</p>
                                                            <p style={{ marginBottom: "0px" }}>Calle 14 No. 10 - 26</p>
                                                            <p style={{ marginBottom: "0px" }}>La Playa, Atlántico</p>
                                                            <hr />
                                                            <p style={{ marginBottom: "0px" }}><b>Cliente:</b> {this.state.facturas.PACIENTE}</p>
                                                            <p style={{ marginBottom: "0px" }}><b>Identificación:</b> {this.state.facturas.IDENTIFICACION}</p>
                                                            <p style={{ marginBottom: "0px" }}><b>Teléfono:</b> {this.state.facturas.CELULAR}</p>
                                                            <hr />
                                                            <p style={{ marginBottom: "0px" }}><b>Factura</b></p>
                                                            <p style={{ marginBottom: "0px" }}><b>No.:  {this.state.facturas.ID_FACTURA}</b></p>
                                                            <p style={{ marginBottom: "0px" }}><b>Fecha:</b> {this.state.facturas.FECHA_FACTURA}</p>
                                                            <hr />
                                                            {/* {this.state.detalles.map((item) => (
                                                                <p key={item.ID_DETALLE}>
                                                                {item.SERVICIO} - ${currencyFormat(item.PRECIO)} <br />
                                                                <small>Pagado: ${currencyFormat(item.PAGADO)}</small>
                                                                </p>
                                                            ))} */}
                                                            <table style={{ width: "100%", fontSize: "14px", borderCollapse: "collapse", backgroundColor: "transparent" }}>
                                                                <thead>
                                                                    <tr>
                                                                        <th style={{ textAlign: "left", border: "none", background: "transparent" }}>CATEGORIA</th>
                                                                        <th style={{ textAlign: "left", border: "none", background: "transparent" }}>SERVICIO</th>
                                                                        <th style={{ textAlign: "right", border: "none", background: "transparent" }}>PRECIO</th>
                                                                        {/* <th style={{ textAlign: "right", border: "none", background: "transparent" }}>Pagado</th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {this.state.detalles.map((item) => (
                                                                        <tr key={item.ID_DETALLE}>
                                                                            <td style={{ textAlign: "left", border: "none", background: "transparent" }}>{item.CATEGORIA}</td>
                                                                            <td style={{ textAlign: "left", border: "none", background: "transparent" }}>{item.SERVICIO}</td>
                                                                            <td style={{ textAlign: "right", border: "none", background: "transparent" }}>${currencyFormat(item.PRECIO)}</td>
                                                                            {/* <td style={{ textAlign: "right" }}>${currencyFormat(item.PAGADO)}</td> */}
                                                                        </tr>
                                                                    ))}
                                                                </tbody>
                                                            </table>
                                                            <hr />
                                                            {/* <p><b>Total:</b> ${currencyFormat(this.state.facturas?.TOTAL_FACTURA || 0)}</p>
                                                            <p><b>Saldo pendiente:</b> ${currencyFormat(this.state.facturas?.SALDO_PENDIENTE || 0)}</p> */}
                                                            <table style={{ width: "100%", fontSize: "14px", borderCollapse: "collapse", backgroundColor: "transparent" }}>
                                                                <tbody>
                                                                    <tr>
                                                                        <td style={{ textAlign: "left", border: "none", background: "transparent" }}><b>TOTAL</b></td>
                                                                        <td style={{ textAlign: "right", border: "none", background: "transparent" }}>
                                                                            ${currencyFormat(this.state.facturas?.TOTAL_FACTURA || 0)}
                                                                        </td>
                                                                    </tr>
                                                                </tbody>
                                                            </table>
                                                            <hr />
                                                            <p>¡Gracias por su compra!</p>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="modal-footer">
                                                <button type="button" className="btn btn-secondary btn-sm" onClick={this.closeFacturaModal}>Cancelar</button>
                                                <button type="button" className="btn btn-primary btn-sm" onClick={this.printFactura}>Imprimir</button>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className={`modal-backdrop fade ${animateInfo ? 'show' : ''}`}></div>
                            </>
                        )
                    }
                </div>
            </div>
        );
    }
}

export default Editar;